import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import { Box, Typography } from '@mui/material';
import TileTitle from '../../common/tileTitle';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import dayjs from "dayjs";
import { ToggleButton, ToggleButtonGroup } from "../../common/CustomToggleButton";


const LineChartWithTitle = ({ height, width, title, chartData, chart_id }) => {

  const [checked, setChecked] = React.useState("월간");
  const chartData2 = checked==="주간"? chartData.weekProgress:chartData.monthProgress ;

  const target =  checked==="주간"? chartData.weekTarget?.toFixed(2):chartData.monthTarget?.toFixed(2) ;

  const onCheckedChange = (event, selectedValue) => {
    if (selectedValue !== null) {
      setChecked(selectedValue);
    }
  };

  const unit = chartData2 && chartData2[0]?.unit;

  useEffect(() => {

    if (!chartData2 || chartData2.length===0) return;


    const sum = chartData2.reduce((acc, dataPoint) => acc + dataPoint.EV, 0);
    const averageValue = sum / chartData2.length;


    const maxYaxis =(_.maxBy(chartData2, "EV").EV)*1.2

    var root = am5.Root.new(chart_id);

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themes_Animated.new(root)
    ]);


    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: true,
      panY: true,
      wheelX: "panX",
      wheelY: "zoomX",
      pinchZoomX: true,
      paddingLeft: 0
    }));

    // chart.zoomOutButton.set("forceHidden", true);
    chart.plotContainer.onPrivate("height", function(height) {
      chart.zoomOutButton.set("dy", height - 45);
      chart.zoomOutButton.set('scale',0.8)

    });
    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineX.set("forceHidden", true);
    cursor.lineY.set("forceHidden", true);

    let xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 30,
      cellStartLocation: 0.1,
      cellEndLocation: 0.9,
      strokeOpacity: 0,
      // strokeWidth: 1,
      // stroke: "rgba(224, 224, 224, 0.5)",
    });

    var xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "date",
        renderer: xRenderer
      })
    );


    xRenderer.grid.template.setAll({
      location: 1,
      strokeOpacity: 0,
    });


    xRenderer.labels.template.adapters.add("text", (text, target) => {
      if (target.dataItem) {

        const category = target.dataItem.dataContext.date;

        if (category.includes("월")) {
          const date = dayjs(category, "YY년 MM월");

          const valueList = target.dataItem.component._data._values;
          const categoryIndex = _.findIndex(valueList, { date: category })

          const year = date.year();
          const month = date.month() + 1;

          if (categoryIndex === 0 || year !== dayjs(target.dataItem.component._data._values[categoryIndex - 1]?.date, "YY년 MM월").year()) {
            return category.split(" ")[0];
          } else {
            return `${month}월`;
          }
        } else {
          const date = dayjs(category, "YY년 WW주차");

          const valueList = target.dataItem.component._data._values;
          const categoryIndex = _.findIndex(valueList, { date: category })

          const year = date.year();

          if (categoryIndex === 0 || year !== dayjs(target.dataItem.component._data._values[categoryIndex - 1]?.date, "YY년 WW주차").year()) {
            return category.split(" ")[0];
          } else {
            return category.split(" ")[1].slice(0, 3);
          }
        }
        return text;
      }
    });

    // Set the data on the xAxis
    xAxis.data.setAll(chartData2);

    xAxis.get("renderer").labels.template.setAll({
      // oversizedBehavior: "fit",
      oversizedBehavior: "wrap",
      textAlign: "center",
      fill: "#525252",
      maxWidth: 50,
      fontSize: "0.8rem",
      minScale: 0.6
    });

    let yRenderer = am5xy.AxisRendererY.new(root, {
      strokeOpacity: 1,
      strokeWidth: 1,
      stroke: "rgba(224, 224, 224, 0.5)",
      grid: {
        disabled: true,
      },
    });

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        strictMinMaxSelection: true,
        extraMin: 0,
        max:maxYaxis,
        // extraMax: 0.3,
        renderer: yRenderer,
      })
    );


    let yAxislabel = am5.Label.new(root, {
      rotation: 0,
      // text: unit,
      y: am5.p50,
      centerX: am5.p50,
      fill: "#FFF",
      //x: am5.p0,
      //centerY: am5.p0
    });

    yAxis.children.unshift(yAxislabel);


    yRenderer.grid.template.setAll({
      strokeOpacity: 0,
    });

    yRenderer.labels.template.setAll({
      paddingRight: 10,
      scale: 0.7,
      fill: "#525252",
    });

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var series = chart.series.push(am5xy.LineSeries.new(root, {
      name: "생산성",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "EV",
      categoryXField: "date",
      tooltip: am5.Tooltip.new(root, {
        labelText: "[fontSize: 12px]{valueY}"
      })
    }));

    series.fills.template.setAll({
      fillOpacity: 0.2,
      visible: true
    });



    series.data.setAll(chartData2);


    // Add series range for the target value
    var targetRangeDataItem = yAxis.makeDataItem({ value: target, endValue: 0 });
    var targetRange = series.createAxisRange(targetRangeDataItem);
    targetRange.fills.template.setAll({
      visible: true,
      opacity: 0.3
    });

    targetRange.fills.template.set("fill", am5.color(0x000000));
    targetRange.strokes.template.set("stroke", am5.color(0x000000));

    targetRangeDataItem.get("grid").setAll({
      strokeOpacity: 1,
      visible: true,
      stroke: am5.color(0x000000),
      strokeDasharray: [2, 2]
    });

    targetRangeDataItem.get("label").setAll({
      location: 0,
      visible: true,
      text: `목표 ${target}`,
      inside: true,
      centerX: 0,
      centerY: am5.p100,
      fontWeight: "bold"
    });

    // Add series range for the average value
    var averageRangeDataItem = yAxis.makeDataItem({ value: averageValue, endValue: 0 });
    var averageRange = series.createAxisRange(averageRangeDataItem);
    averageRange.fills.template.setAll({
      visible: true,
      opacity: 0.3
    });

    averageRange.fills.template.set("fill", am5.color(0xFF0000));
    averageRange.strokes.template.set("stroke", am5.color(0xFF0000));

    averageRangeDataItem.get("grid").setAll({
      strokeOpacity: 1,
      visible: true,
      stroke: am5.color(0xFF0000),
      strokeDasharray: [2, 2]
    });

    averageRangeDataItem.get("label").setAll({
      location: 0,
      visible: true,
      text: `평균 ${averageValue.toFixed(2)}`,
      inside: true,
      centerX: 0,
      centerY: am5.p0,
      fontWeight: "bold",
      fill: am5.color(0xFF0000)
    });



    //Find the highest and lowest data points
  let maxValue = Number.NEGATIVE_INFINITY;
  let minValue = Number.POSITIVE_INFINITY;
  let maxDataPoint = null;
  let minDataPoint = null;

  chartData2.forEach((dataPoint) => {
    if (dataPoint.EV > maxValue) {
      maxValue = dataPoint.EV;
      maxDataPoint = dataPoint;
    }
    if (dataPoint.EV < minValue) {
      minValue = dataPoint.EV;
      minDataPoint = dataPoint;
    }
  });

  series.bullets.push(function (root, series, dataItem) {
    let dataContext = dataItem.dataContext;
  
    if (dataContext.EV === maxValue) {
      // Max value - blue color
      return am5.Bullet.new(root, {
        locationY: 0,
        sprite: am5.Label.new(root, {
          text: "{valueY.formatNumber('#,###.##')}",
          centerY: am5.p50,
          centerX: am5.p50,
          populateText: true,
          fontSize: "0.8em",
          fontWeight: "bold",
          fill:"#359AF3", // White text
          // background: am5.Rectangle.new(root, {
          //   fill: am5.color(0x0000FF), // Blue background
          //   fillOpacity: 0.8,
          //   cornerRadius: 5,
          // }),
          dy: -20,
          padding: 5,
        }),
      });
    } else if (dataContext.EV === minValue) {
      // Min value - red color
      return am5.Bullet.new(root, {
        locationY: 0,
        sprite: am5.Label.new(root, {
          text: "{valueY.formatNumber('#,###.##')}",
          centerY: am5.p50,
          centerX: am5.p50,
          fontSize: "0.8em",
          fontWeight: "bold",
          populateText: true,
          fill: "#F8443E",
          // background: am5.Rectangle.new(root, {
          //   fill: am5.color(0xFF0000), // Red background
          //   fillOpacity: 0.8,
          //   cornerRadius: 5,
          // }),
          dy: -20,
          padding: 5,
        }),
      });
    }
  
    return null;
  });
    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series.appear(1000);
    chart.appear(1000, 100);

    return () => {

      root && root.dispose();

    };
  }, [
    chartData2, chart_id, unit, target
  ]);




  return (
    <div style={{ position: 'relative', width: '100%', height: height }}>
    <Box
      sx={{
        padding: '20px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '10px',
          height: 28,
          borderBottom: '1px solid #D1D1D1',
        }}
      >
        <TileTitle>{title}</TileTitle>
        <div
          style={{
            zIndex: 99999,
            fontSize: 12,
            marginRight:8,
            // height: 40,
            // width: 325,
            whiteSpace: 'nowrap',
          }}
       
        >{unit}/MD</div>
      </Box>

      <Box sx={{ position: 'relative', flexGrow: 1 }}>
        {chartData && chartData.monthProgress && chartData.monthProgress.length > 0 ? (
          
          <>
            <div style={{ position: 'absolute', top: 0, left: 0 }}>
              <ToggleButtonGroup
                className="no-drag-button"
                size="small"
                onChange={onCheckedChange}
                value={checked}
                exclusive
                aria-label="baseunit"
              >
                <ToggleButton value="월간" aria-label="monthly">
                  월간
                </ToggleButton>
                <ToggleButton value="주간" aria-label="weekly">
                  주간
                </ToggleButton>
              </ToggleButtonGroup>
            </div>

            <div id={chart_id} style={{position: 'absolute', bottom: 0, width: '100%', height: 'calc(100% - 40px)'  }} />
            </>
        ) 
        : (
          // Show a message if there's no data
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <Typography variant="body2">데이터가 존재하지 않습니다.</Typography>
          </Box>
        )}
      </Box>
    </Box>
    </div>
  );
}



export default LineChartWithTitle

